import { Loader } from '@oy/uidesktop';
import { Navigate, useParams } from 'react-router-dom';
import { useEnv, useProductConfigs, useRoute, useSwitchEnv } from 'src/hooks';

export function ProductionRoute() {
  const params = useParams();

  const { switchProduction } = useSwitchEnv();
  const { isProdEnv } = useEnv();

  const { state, redirectUrl } = useRoute();
  const { isRedirect, isUserLoggedOut } = state;
  const { isLoading } = useProductConfigs();

  if (isLoading) return <Loader />;
  if (isRedirect || isUserLoggedOut)
    return <Navigate to={redirectUrl()} replace />;

  const mainUrl = `/${params['*']}`;

  const switchEnv = async () => {
    await switchProduction(mainUrl);
    return <></>;
  };

  if (!isProdEnv) switchEnv();

  return <Navigate to={mainUrl} replace />;
}
